var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClockGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clock (2)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-(2)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 3.000000)",
    fill: "#2B2B2D",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0 C4.26148989,0 0,4.26148989 0,9.5 C0,14.7385101 4.26148989,19 9.5,19 C14.7385101,19 19,14.7385101 19,9.5 C19,4.26148989 14.7385101,0 9.5,0 Z M14.0180664,14.4138031 C13.8636856,14.5681839 13.6610336,14.6458817 13.4583817,14.6458817 C13.2557297,14.6458817 13.0529328,14.5681839 12.8986969,14.4138031 L8.94031526,10.4555664 C8.79144287,10.3075638 8.70838166,10.1063614 8.70838166,9.89588166 L8.70838166,4.75 C8.70838166,4.31222534 9.06295012,3.95838166 9.5,3.95838166 C9.93704987,3.95838166 10.2916183,4.31222534 10.2916183,4.75 L10.2916183,9.56813051 L14.0180664,13.2944336 C14.3275528,13.6040649 14.3275528,14.1043167 14.0180664,14.4138031 L14.0180664,14.4138031 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockGrey);
export default __webpack_public_path__ + "static/media/ic_clock_grey.d4179a8a.svg";
export { ForwardRef as ReactComponent };